module.exports = __webpack_public_path__ + "static/media/reward-catalouge-5.18d437a8.png";